import { render, staticRenderFns } from "./baserespaldatoriosenvios.vue?vue&type=template&id=19da6ed6"
import script from "./baserespaldatoriosenvios.vue?vue&type=script&lang=js"
export * from "./baserespaldatoriosenvios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports